(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-announcement"] && !Shopify.designMode) return;
  try {
    
  class SCAnnouncement extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.sc-announce__item'));
      const speed = parseInt(this.dataset.autorotate || '0', 10);
      if (!speed || this.items.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.index = 0;
      this.timer = setInterval(() => this.advance(), speed * 1000);
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    advance() {
      this.items[this.index].classList.remove('is-active');
      this.items[this.index].setAttribute('aria-hidden', 'true');
      this.index = (this.index + 1) % this.items.length;
      this.items[this.index].classList.add('is-active');
      this.items[this.index].removeAttribute('aria-hidden');
    }
  }

  if (!customElements.get('sc-announcement')) {
    customElements.define('sc-announcement', SCAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-creators"] && !Shopify.designMode) return;
  try {
    
  class SCCreators extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[ref="play"]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const card = btn.closest('.sc-crt__hero, .sc-crt__c');
          const video = card?.querySelector('video');
          if (!video) return;

          // Only one clip plays at a time.
          this.querySelectorAll('video').forEach((v) => {
            if (v !== video) {
              v.pause();
              v.muted = true;
              v.closest('.sc-crt__hero, .sc-crt__c')?.classList.remove('is-playing');
            }
          });

          video.muted = false;
          video.controls = true;
          card.classList.add('is-playing');
          video.play();
        });
      });
    }
  }

  if (!customElements.get('sc-creators')) {
    customElements.define('sc-creators', SCCreators);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-header"] && !Shopify.designMode) return;
  try {
    
  class SCHeader extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('[ref="drawer"]');
      this.burger = this.querySelector('[ref="burger"]');
      this.closeBtn = this.querySelector('[ref="close"]');

      this.burger?.addEventListener('click', () => this.setDrawer(true));
      this.closeBtn?.addEventListener('click', () => this.setDrawer(false));
      this.drawer?.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => this.setDrawer(false)));

      // Desktop dropdowns — click to open, click-outside / Escape to close.
      this.dropdowns = Array.from(this.querySelectorAll('.sc-header__has-menu'));
      this.dropdowns.forEach((dd) => {
        const trigger = dd.querySelector('a');
        trigger?.addEventListener('click', (e) => {
          e.preventDefault();
          const open = !dd.classList.contains('is-open');
          this.closeDropdowns();
          dd.classList.toggle('is-open', open);
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });

      this.onDocClick = (e) => {
        if (!this.dropdowns.some((dd) => dd.contains(e.target))) this.closeDropdowns();
      };
      this.onKey = (e) => {
        if (e.key !== 'Escape') return;
        this.closeDropdowns();
        this.setDrawer(false);
      };
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKey);

      this.#trackAnnouncementHeight();
    }

    /**
     * Publishes the announcement bar's height so the sticky header can offset
     * by it — the bar scrolls away, the nav pins. Re-measured on resize because
     * the message can wrap to two lines on narrow screens.
     */
    #trackAnnouncementHeight() {
      if (!this.classList.contains('sc-header--sticky')) return;

      const group = document.getElementById('header-group');
      if (!group) return;

      const measure = () => {
        let above = 0;
        for (const child of group.children) {
          if (child.contains(this)) break;
          if (child instanceof HTMLElement) above += child.offsetHeight;
        }
        group.style.setProperty('--sc-announce-h', `${above}px`);
      };

      measure();
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(measure);
        for (const child of group.children) {
          if (child instanceof HTMLElement && !child.contains(this)) {
            this.resizeObserver.observe(child);
          }
        }
      }
      window.addEventListener('resize', measure);
      this.onResize = measure;
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKey);
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      this.resizeObserver?.disconnect();
      document.body.style.overflow = '';
    }

    closeDropdowns() {
      this.dropdowns.forEach((dd) => {
        dd.classList.remove('is-open');
        dd.querySelector('a')?.setAttribute('aria-expanded', 'false');
      });
    }

    setDrawer(open) {
      if (!this.drawer) return;
      this.drawer.hidden = !open;
      this.burger?.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) this.closeBtn?.focus();
      else this.burger?.focus();
    }
  }

  if (!customElements.get('sc-header')) {
    customElements.define('sc-header', SCHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-hero"] && !Shopify.designMode) return;
  try {
    
  class SCHero extends HTMLElement {
    connectedCallback() {
      const btn = this.querySelector('[ref="reveal"]');
      const mark = btn?.querySelector('.sc-wm--animate');
      if (!btn || !mark) return;

      btn.addEventListener('click', () => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        mark.classList.add('sc-wm--replay');
        // Force a reflow so the animation restarts from frame zero.
        void mark.offsetWidth;
        mark.classList.remove('sc-wm--replay');
      });
    }
  }

  if (!customElements.get('sc-hero')) {
    customElements.define('sc-hero', SCHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-list"] && !Shopify.designMode) return;
  try {
    
  class SCList extends HTMLElement {
    connectedCallback() {
      const submit = this.querySelector('[ref="submit"]');
      if (!submit) {
        // Already submitted — reveal the event details as the reward.
        this.querySelector('[ref="redacted"]')?.classList.add('is-open');
        const foot = this.querySelector('[ref="redactedFoot"]');
        if (foot && foot.dataset.revealed) foot.textContent = foot.dataset.revealed;
        return;
      }

      const fields = ['handle', 'email', 'age', 'consent']
        .map((r) => this.querySelector(`[ref="${r}"]`))
        .filter(Boolean);

      const valid = () =>
        fields.every((el) =>
          el.type === 'checkbox' ? el.checked : el.value.trim().length > (el.type === 'email' ? 4 : 1)
        ) && /.+@.+\..+/.test(this.querySelector('[ref="email"]')?.value || '');

      const sync = () => {
        submit.disabled = !valid();
      };

      fields.forEach((el) => {
        el.addEventListener('input', sync);
        el.addEventListener('change', sync);
      });
      sync();
    }
  }

  if (!customElements.get('sc-list')) {
    customElements.define('sc-list', SCList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-product-main"] && !Shopify.designMode) return;
  try {
    
  class SCProduct extends HTMLElement {
    connectedCallback() {
      this.variants = this.#readVariants();
      this.selected = {};

      this.priceEl = this.querySelector('[ref="price"]');
      this.compareEl = this.querySelector('[ref="compare"]');
      this.savePill = this.querySelector('[ref="savePill"]');
      this.pctPill = this.querySelector('[ref="pctPill"]');
      this.variantInput = this.querySelector('[ref="variantId"]');
      this.atc = this.querySelector('[ref="atc"]');
      this.atcText = this.querySelector('[ref="atcText"]');
      this.stockLine = this.querySelector('[ref="stockLine"]');
      this.stockText = this.querySelector('[ref="stockText"]');
      this.titleVariant = this.querySelector('[ref="titleVariant"]');
      this.optReadouts = this.querySelectorAll('[data-opt-readout]');

      this.#seedSelectionFromMarkup();
      this.#bindOptions();
      this.#bindGallery();
      this.#bindQuantity();
      this.#bindUgc();
      this.#update();
    }

    #readVariants() {
      const el = this.querySelector('[ref="variantData"]');
      if (!el) return [];
      try {
        return JSON.parse(el.textContent) || [];
      } catch {
        return [];
      }
    }

    #seedSelectionFromMarkup() {
      this.querySelectorAll('[data-option-index]:not([data-set])[aria-pressed="true"]').forEach((btn) => {
        this.selected[btn.dataset.optionIndex] = btn.dataset.value;
      });
    }

    #bindOptions() {
      // :not([data-set]) excludes the bundle builder's buttons, which live in
      // the same buy column and use the same attribute for their own sets.
      this.querySelectorAll('[data-option-index]:not([data-set])').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (btn.classList.contains('is-unavailable') && btn.tagName === 'BUTTON' && btn.disabled) return;
          const idx = btn.dataset.optionIndex;
          this.querySelectorAll(`[data-option-index="${idx}"]:not([data-set])`).forEach((o) =>
            o.setAttribute('aria-pressed', 'false')
          );
          btn.setAttribute('aria-pressed', 'true');
          this.selected[idx] = btn.dataset.value;
          this.#update();
        });
      });
    }

    #match() {
      const chosen = Object.keys(this.selected)
        .sort((a, b) => Number(a) - Number(b))
        .map((k) => this.selected[k]);
      if (!chosen.length) return this.variants[0];
      return this.variants.find((v) => v.options.every((o, i) => o === chosen[i]));
    }

    #update() {
      const variant = this.#match();
      this.#markUnavailable();

      if (!variant) {
        if (this.atc) this.atc.disabled = true;
        if (this.atcText) this.atcText.textContent = this.atc?.dataset.labelUnavailable || 'Unavailable';
        return;
      }

      if (this.variantInput) this.variantInput.value = variant.id;
      if (this.priceEl) this.priceEl.textContent = variant.price;

      if (this.compareEl) {
        this.compareEl.textContent = variant.compare;
        this.compareEl.classList.toggle('is-hidden', !variant.onSale);
      }
      [this.savePill, this.pctPill].forEach((el) => el?.classList.toggle('is-hidden', !variant.onSale));

      if (this.atc) this.atc.disabled = !variant.available;
      if (this.atcText) {
        this.atcText.textContent = variant.available
          ? this.atc.dataset.labelAvailable || this.atcText.dataset.original || this.atcText.textContent
          : this.atc.dataset.labelSoldOut || 'Sold out';
      }

      if (this.stockLine) this.stockLine.classList.toggle('is-out', !variant.available);
      if (this.titleVariant) this.titleVariant.textContent = ' — ' + variant.options[0];

      // Keep each option's readout ("Colour: Sand") in step with the choice.
      this.optReadouts?.forEach((el) => {
        const value = variant.options[Number(el.dataset.optReadout) - 1];
        if (value) el.textContent = value;
      });

      // Swap the gallery to the variant's own image.
      if (variant.mediaPos > 0) this.#showSlide(variant.mediaPos - 1);

      // Keep the URL shareable without a reload.
      if (this.dataset.updateUrl === 'true' && variant.url) {
        window.history.replaceState({}, '', variant.url);
      }
    }

    // Cross out option values that have no available variant given the other picks.
    #markUnavailable() {
      // :not([data-set]) excludes the bundle builder's buttons, which live in
      // the same buy column and use the same attribute for their own sets.
      this.querySelectorAll('[data-option-index]:not([data-set])').forEach((btn) => {
        const idx = Number(btn.dataset.optionIndex);
        const trial = { ...this.selected, [idx]: btn.dataset.value };
        const chosen = Object.keys(trial)
          .sort((a, b) => Number(a) - Number(b))
          .map((k) => trial[k]);
        const exists = this.variants.some(
          (v) => v.available && chosen.every((val, i) => v.options[i] === val)
        );
        btn.classList.toggle('is-unavailable', !exists);
      });
    }

    #bindGallery() {
      this.slides = Array.from(this.querySelectorAll('.sc-pdp__slide'));
      this.thumbs = Array.from(this.querySelectorAll('.sc-pdp__thumb'));
      this.index = 0;

      this.thumbs.forEach((t) =>
        t.addEventListener('click', () => this.#showSlide(Number(t.dataset.index)))
      );
      this.querySelector('[ref="prev"]')?.addEventListener('click', () => this.#showSlide(this.index - 1));
      this.querySelector('[ref="next"]')?.addEventListener('click', () => this.#showSlide(this.index + 1));

      // Swipe on touch devices.
      const stage = this.querySelector('[ref="stage"]');
      if (!stage) return;
      let startX = null;
      stage.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
      stage.addEventListener(
        'touchend',
        (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) this.#showSlide(this.index + (dx < 0 ? 1 : -1));
          startX = null;
        },
        { passive: true }
      );
    }

    #showSlide(n) {
      if (!this.slides.length) return;
      this.index = (n + this.slides.length) % this.slides.length;
      this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.index));
      this.thumbs.forEach((t, i) => t.setAttribute('aria-selected', i === this.index ? 'true' : 'false'));
      this.#revealThumb(this.thumbs[this.index]);
    }

    /**
     * Bring a thumbnail into view by scrolling ONLY its own strip.
     *
     * This used to be scrollIntoView({ block: 'nearest' }). Despite the name,
     * that walks every scrollable ancestor — including the page — so choosing a
     * size or a colour scrolled the whole document a little, which is the jump
     * felt when switching between White and Sand. Setting scrollLeft/scrollTop
     * on the strip itself moves the strip and nothing else.
     */
    #revealThumb(thumb) {
      if (!thumb) return;

      const strip = thumb.parentElement;
      if (!strip) return;

      const overflowsX = strip.scrollWidth > strip.clientWidth;
      const overflowsY = strip.scrollHeight > strip.clientHeight;
      if (!overflowsX && !overflowsY) return;

      const t = thumb.getBoundingClientRect();
      const s = strip.getBoundingClientRect();

      if (overflowsX) {
        if (t.left < s.left) {
          strip.scrollLeft -= s.left - t.left;
        } else if (t.right > s.right) {
          strip.scrollLeft += t.right - s.right;
        }
      }

      if (overflowsY) {
        if (t.top < s.top) {
          strip.scrollTop -= s.top - t.top;
        } else if (t.bottom > s.bottom) {
          strip.scrollTop += t.bottom - s.bottom;
        }
      }
    }

    /** Creator clips: reveal the video on play, and only one at a time. */
    #bindUgc() {
      this.querySelectorAll('[data-ugc-play]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const card = btn.closest('.sc-ugc__card');
          const wrap = card?.querySelector('.sc-ugc__video');
          const video = wrap?.querySelector('video');
          if (!video) return;

          this.querySelectorAll('.sc-ugc__card.is-playing').forEach((other) => {
            if (other === card) return;
            other.classList.remove('is-playing');
            const v = other.querySelector('video');
            if (v) {
              v.pause();
              v.currentTime = 0;
            }
            const w = other.querySelector('.sc-ugc__video');
            if (w) w.hidden = true;
          });

          wrap.hidden = false;
          card.classList.add('is-playing');
          video.play();
        });
      });
    }

    #bindQuantity() {
      const input = this.querySelector('[ref="qtyInput"]');
      if (!input) return;
      const step = (delta) => {
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      this.querySelector('[ref="qtyMinus"]')?.addEventListener('click', () => step(-1));
      this.querySelector('[ref="qtyPlus"]')?.addEventListener('click', () => step(1));
    }
  }

  if (!customElements.get('sc-product')) {
    customElements.define('sc-product', SCProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-size-guide"] && !Shopify.designMode) return;
  try {
    
  class SCSizeGuide extends HTMLElement {
    connectedCallback() {
      this.state = { size: 'all', bust: 'all' };
      this.models = Array.from(this.querySelectorAll('.sc-sg__model'));
      this.empty = this.querySelector('[ref="empty"]');

      this.querySelectorAll('.sc-sg__fgroup').forEach((group) => {
        const key = group.dataset.filter;
        group.querySelectorAll('.sc-chip').forEach((chip) => {
          chip.addEventListener('click', () => {
            group.querySelectorAll('.sc-chip').forEach((c) => c.setAttribute('aria-pressed', 'false'));
            chip.setAttribute('aria-pressed', 'true');
            this.state[key] = chip.dataset.value;
            this.apply();
          });
        });
      });

      this.apply();
    }

    apply() {
      let any = false;
      this.models.forEach((m) => {
        const ok =
          (this.state.size === 'all' || m.dataset.size === this.state.size) &&
          (this.state.bust === 'all' || m.dataset.bust === this.state.bust);
        m.hidden = !ok;
        if (ok) any = true;
      });
      if (this.empty) this.empty.hidden = any;
    }
  }

  if (!customElements.get('sc-size-guide')) {
    customElements.define('sc-size-guide', SCSizeGuide);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  class SCStickyAtc extends HTMLElement {
    connectedCallback() {
      // Anchor to the main add-to-cart button so the bar appears only once it
      // has scrolled out of view. Excludes the bundle CTA, which shares the
      // .sc-atc class but is a different action.
      this.target = document.querySelector('.sc-atc:not(.sc-bundle__cta)');
      this.btn = this.querySelector('[ref="btn"]');
      this.price = this.querySelector('[ref="price"]');

      this.btn?.addEventListener('click', () => {
        if (!this.target) return;
        this.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        // Focus the first unselected option so the customer knows what's missing.
        if (this.target.disabled) {
          document.querySelector('.sc-size:not([aria-pressed="true"])')?.focus();
        } else {
          this.target.click();
        }
      });

      if (!this.target || !('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(
        ([entry]) => this.classList.toggle('is-visible', !entry.isIntersecting),
        { threshold: 0 }
      );
      this.observer.observe(this.target);

      // Mirror the live price from the buy column.
      const source = document.querySelector('[ref="price"]');
      if (source && this.price) {
        this.mirror = new MutationObserver(() => {
          this.price.textContent = source.textContent;
        });
        this.mirror.observe(source, { childList: true, characterData: true, subtree: true });
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.mirror?.disconnect();
    }
  }

  if (!customElements.get('sc-sticky-atc')) {
    customElements.define('sc-sticky-atc', SCStickyAtc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-wall"] && !Shopify.designMode) return;
  try {
    
  class SCWall extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.sc-wall__card'));
      this.filter = null;

      // Reveal / re-hide a secret.
      this.cards.forEach((card) => {
        const toggle = () => {
          const open = card.classList.toggle('is-open');
          card.setAttribute('aria-pressed', open ? 'true' : 'false');
        };
        card.addEventListener('click', toggle);
        card.addEventListener('keydown', (e) => {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          toggle();
        });
      });

      // Word cloud filtering.
      this.querySelectorAll('[ref="cloud"] button').forEach((btn) => {
        btn.addEventListener('click', () => {
          const word = btn.dataset.word;
          const on = this.filter !== word;
          this.filter = on ? word : null;
          this.querySelectorAll('[ref="cloud"] button').forEach((o) => {
            o.setAttribute('aria-pressed', o === btn && on ? 'true' : 'false');
          });
          this.applyFilter();
        });
      });

      // Character counter + submit gating.
      const input = this.querySelector('[ref="input"]');
      const chars = this.querySelector('[ref="chars"]');
      const submit = this.querySelector('[ref="submit"]');
      if (input && submit) {
        input.addEventListener('input', () => {
          if (chars) chars.textContent = String(input.value.length);
          submit.disabled = input.value.trim().length < 8;
        });
      }
    }

    applyFilter() {
      this.cards.forEach((card) => {
        const hit = !this.filter || (card.dataset.text || '').includes(this.filter);
        card.classList.toggle('is-dim', !hit);
      });
    }
  }

  if (!customElements.get('sc-wall')) {
    customElements.define('sc-wall', SCWall);
  }

  } catch(e) { console.error(e); }
})();
})();
